package com.nonopn.skywatcher.common.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class APIUserSession(
    @SerialName("persistence_token")
    val persistenceToken: String,
    val login: String,
    val email: String,
    val admin: Boolean? = false,
    val name: String? = null,
    val surname: String? = null,
    val language: String? = "en",
    val gmt: Int? = 0,
    val uuid: String?,
    val firstname: String? = null,
    @SerialName("vault_size")
    val vaultSize: Long? = 0,
    val gems: Long? = 0,
    // val latitude: BigDecimal?,
    // val longitude: BigDecimal?,
    @SerialName("lightning_radius")
    val lightningRadius: Int? = 0,
    @SerialName("lightning_notification_type")
    val lightningNotificationType: String? = null,
    // val business: BusinessModel? = null,
    val rights: List<String>? = null
)

/**
 * Administrator rule of the backend: GET /user `rights` contains "administrator" (required by /api/admin).
 * The `admin` field can be true without this right, so it is not used.
 */
fun APIUserSession.isAdministrator(): Boolean = rights?.any { it.equals("administrator", ignoreCase = true) } == true
